/* unplugin-vue-components disabled */import script from "./ContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./ContractDetail.vue?vue&type=style&index=0&id=ef2e87ba&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef2e87ba"]])

export default __exports__